<template>
  <Modal :id="'cmp-royalty-royalty_accounts-new_account'" @cancelled="onCancel">
    <template slot="header">{{
      $dft.snakeCaseToWords("new_royalty_account")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'account_name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="accountData.royalty_account_name"
            isModel
            :placeholder="$t('account_name')"
            @valuechanged="onTextFieldValueChange"
            required
            showValidationIcons
            @validated="onValidation"
          />
          <Dropdown
            :id="'royalty_period'"
            class="m2"
            :options="royalty_periodsTV"
            :selected="
              royalty_periodsTV.find(
                (x) => x.value == accountData.royalty_period
              )
            "
            :placeholder="$t('royalty_period')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('royalty_period', e)"
          ></Dropdown>
          <Dropdown
            :id="'payment_yes_no'"
            class="m2"
            showValidationIcons
            required
            immediateValidation
            @validated="(e) => onValidation('payment_yes_no', e)"
            :options="account_basesTV"
            :selected="
              account_basesTV.find((x) => x.value == accountData.payment_yes_no)
            "
            :placeholder="$t('Account Base')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('payment_yes_no', e)"
          ></Dropdown>
          <Dropdown
            showValidationIcons
            required
            immediateValidation
            @validated="(e) => onValidation('invoice_project_id', e)"
            class="dt-dropdown m2"
            :options="invoiceProjectTV"
            box
            :placeholder="$t('royalty_project')"
            v-on:selectedChange="
              (e) => onDropdownChange('invoice_project_id', e)
            "
            :listHeight="150"
            :selected="
              invoiceProjectTV.find(
                (b) => b.value == accountData.invoice_project_id
              )
            "
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { AccountsService } from "../../services/accounts.service";
import { createTV, tv } from "../../../../models/text-value.model";
import {
  getAccountsDetailsSelectable,
  royaltyAccountsListLDTRoutes,
} from "../../router/routes";
export default {
  components: {
    Modal,
    TextField,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
      accountData: {
        royalty_account_name: null,
        royalty_period: null,
        invoice_project_id: null,
        payment_yes_no: null,
      },
    };
  },
  mounted() {
    this.getRoyaltyAccountFormData();
  },
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    royalty_periodsTV: function () {
      return createTV(this.accountData.royalty_periods, "label", "value");
    },
    account_basesTV: function () {
      return createTV(this.accountData?.account_bases, "label", "value");
    },
    invoiceProjectTV: function () {
      return createTV(
        this.accountData.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    getRoyaltyAccountFormData: async function () {
      const result = await AccountsService.getNewRoyaltyAccountData();
      this.accountData = {
        ...this.accountData,
        ...result.data,
      };
    },
    onTextFieldValueChange: function (name, value) {
      this.accountData[name] = value;
    },
    onDropdownChange(name, value) {
      this.accountData[name] = value.value;
    },
    onSave: async function () {
      const res = await AccountsService.saveRoyaltyAccount({
        ...this.accountData,
      });
      // console.log('new Track', res.data.tracks);
      this.$emit("added", {
        ...this.accountData,
        royalty_account_id: res.data.royalty_account_id,
      });
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: res.data.royalty_account_id,
          tab: "overview",
        },
      });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style></style>
